<br>


<div class="container">
  <div class="search-results" infiniteScroll [infiniteScrollDistance]="1" [infiniteScrollThrottle]="50"
      (scrolled)="onScroll()" [scrollWindow]="true">
  <div class="row" *ngIf="productList && grid && !showNotAvailableMsg && !enableLoader">
    <div *ngFor="let product of productList,let i=index " class="col-12 col-sm-6 col-lg-3">
      <app-custom-product-card [productInfo]=product [index]=index [browseType]="browseType">
      </app-custom-product-card>
    </div>
  </div>
  <div *ngIf="productList && grid && !showNotAvailableMsg && !enableLoader && loaderShow" id="loader"></div>
  <!-- <div class="text-center strong  text-primary mb-5" *ngIf="productList && grid && !showNotAvailableMsg && !enableLoader && reachedToEnd"> {{ "home.contracts.Nomore" | cxTranslate }}</div> -->
  </div>
</div>
<div *ngIf="enableLoader" id="loader"></div>
<div class="text-center strong  text-primary mb-5" *ngIf="showNotAvailableMsg">{{'common.noData' | cxTranslate}}</div>
<div class="search-results container" infiniteScroll [infiniteScrollDistance]="1" [infiniteScrollThrottle]="50"
  (scrolled)="onScroll()" [scrollWindow]="true">
  <div *ngIf="list && !showNotAvailableMsg && !enableLoader">
    <div *ngFor="let product of productList,let i=index ">
      <!-- <app-products-list-view  [item]=item [index]=index [browseType]=browseType></app-products-list-view> -->
      <app-list-card [productInfo]=product [browseType]=browseType [index]=index></app-list-card>
    </div>
   <div *ngIf="loaderShow" id="loader"></div>
      <!-- <div class="text-center strong  text-primary mb-5" *ngIf="reachedToEnd"> {{ "home.contracts.Nomore" | cxTranslate }}</div> -->
  </div>
</div>
